module.exports = __webpack_public_path__ + "img/genet_baie.8cab5932.jpg";